import React, { useEffect } from 'react';
import { useAuthDataContext } from './AuthDataProvider';
import { RefreshToken } from './Session';


const withAuth = (ProtectedComponent) => {
  const AuthenticatedComponent = (props) => {
    const { user, isLoading, onLogin, onLogout } = useAuthDataContext();

    useEffect(() => {
      if (!isLoading && !user) {
        window.location.assign("/login");
      }
    }, [user, isLoading]);

    if (user) {
      var now = new Date;
      var utc_timestamp = Date.UTC(now.getUTCFullYear(),now.getUTCMonth(), now.getUTCDate() ,
            now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds())/1000;
      console.log("Current Time: ");
      console.log(utc_timestamp);
      console.log("Expiration Time: ");
      console.log(user.expiration);
      if (utc_timestamp > user.expiration) {
        window.location.assign("/refresh?redirect=" + window.location.pathname);
        return null;
      } else{
          console.log("Token still valid");
          return <ProtectedComponent {...props} />;
        }
      }
    return null
  };
  const displayName = ProtectedComponent.displayName || ProtectedComponent.name || 'Component';
  AuthenticatedComponent.displayName = `withAuth(${displayName})`;

  return AuthenticatedComponent;
};

export default withAuth;
